import type { DocumentTypeWithRequirementApiResponse } from '../../features/evidence-files/required-documents.models';

/**
 * 必要書類Mockデータ（共通カテゴリ）
 * employment / journal_entry 双方で必要な書類
 *
 * Issue #443/#447: attributionUnit の 4 パターン（case / employee / month / project）を
 * mock でも網羅するため、case / project 用の DocumentType もここに含める。
 */
export const MOCK_REQUIRED_DOCUMENTS_COMMON: DocumentTypeWithRequirementApiResponse[] =
  [
    {
      publicId: 'doc-type-001',
      code: 'employment_contract',
      name: '雇用契約書',
      category: 'common',
      attributionUnit: 'employee',
      displayOrder: 1,
      isRequired: true,
    },
    {
      publicId: 'doc-type-002',
      code: 'social_insurance_notification',
      name: '社会保険資格取得届',
      category: 'common',
      attributionUnit: 'employee',
      displayOrder: 2,
      isRequired: true,
    },
    {
      publicId: 'doc-type-003',
      code: 'employment_insurance_notification',
      name: '雇用保険被保険者資格取得届',
      category: 'common',
      attributionUnit: 'employee',
      displayOrder: 3,
      isRequired: true,
    },
    {
      publicId: 'doc-type-006',
      code: 'work_report',
      name: '業務報告書',
      category: 'common',
      attributionUnit: 'case',
      displayOrder: 6,
      isRequired: false,
    },
    {
      publicId: 'doc-type-007',
      code: 'organization_chart',
      name: '組織図',
      category: 'common',
      attributionUnit: 'project',
      displayOrder: 7,
      isRequired: false,
    },
  ];

/**
 * 必要書類Mockデータ（雇用審査固有カテゴリ）
 */
export const MOCK_REQUIRED_DOCUMENTS_EMPLOYMENT: DocumentTypeWithRequirementApiResponse[] =
  [...MOCK_REQUIRED_DOCUMENTS_COMMON];

/**
 * 必要書類Mockデータ（仕訳審査固有カテゴリ）
 */
export const MOCK_REQUIRED_DOCUMENTS_JOURNAL_ENTRY: DocumentTypeWithRequirementApiResponse[] =
  [
    ...MOCK_REQUIRED_DOCUMENTS_COMMON,
    {
      publicId: 'doc-type-004',
      code: 'payslip',
      name: '給与明細',
      category: 'journal_entry',
      attributionUnit: 'month',
      displayOrder: 4,
      isRequired: false,
    },
    {
      publicId: 'doc-type-005',
      code: 'attendance_record',
      name: '出勤簿',
      category: 'journal_entry',
      attributionUnit: 'month',
      displayOrder: 5,
      isRequired: false,
    },
  ];

/**
 * 全カテゴリを横断した DocumentType の全件（重複排除済）。
 * PATCH /evidence-files/:evidenceFileId の lookup で reviewType を跨いで検索するために利用する。
 */
export const MOCK_ALL_DOCUMENT_TYPES: DocumentTypeWithRequirementApiResponse[] =
  [...MOCK_REQUIRED_DOCUMENTS_JOURNAL_ENTRY];

/**
 * publicId から DocumentType を検索する（Issue #443/#447 PATCH mock 用）
 */
export function findDocumentTypeByPublicId(
  publicId: string,
): DocumentTypeWithRequirementApiResponse | undefined {
  return MOCK_ALL_DOCUMENT_TYPES.find((doc) => doc.publicId === publicId);
}
